<fadv-layout [fixed]='true'>
    <fadv-layout-main>
        <div class='main'>
            <app-alert-message></app-alert-message>
            <router-outlet></router-outlet>
        </div>
    </fadv-layout-main>
    <fadv-layout-section *ngIf="!hideStepper" position='left'>
        <div *ngIf="!mobile"  style="float: left; padding-right: 5%; width: 200px;">
            <fadv-stepper #partnerStepper [linear]="true" [orientation]="this?.stepperPosition"
                [selectedStep]="currentStep" (stepActivated)="this?.stepActivatedCallBack($event)">
                <fadv-step label="Start" #startStep>
                    <fadv-icon library="solid" name="star"></fadv-icon>
                </fadv-step>
                <fadv-step label="Package" #packageStep>
                    <fadv-icon library="solid" name="cart-plus"></fadv-icon>
                </fadv-step>
                <fadv-step label="Applicant" #candidateStep>
                    <fadv-icon library="solid" name="user"></fadv-icon>
                </fadv-step>
                <fadv-step label="Payment" #paymentStep>
                    <fadv-icon library="solid" name="credit-card"></fadv-icon>
                </fadv-step>
                <fadv-step label="Account" #accountStep>
                    <fadv-icon library="solid" name="user"></fadv-icon>
                </fadv-step>
                <fadv-step label="Credentialing" #credentialingStep>
                    <fadv-icon library="solid" name="flag-checkered"></fadv-icon>
                </fadv-step>
            </fadv-stepper>
        </div>
        <div *ngIf="mobile" class='left' style="padding-bottom: 2%">
            <fadv-stepper #partnerStepper [linear]="true" [orientation]="this?.stepperPosition"
                [selectedStep]="currentStep" (stepActivated)="this?.stepActivatedCallBack($event)">
                <fadv-step label="Start" #startStep>
                    <fadv-icon library="solid" name="star"></fadv-icon>
                </fadv-step>
                <fadv-step label="Package" #packageStep>
                    <fadv-icon library="solid" name="cart-plus"></fadv-icon>
                </fadv-step>
                <fadv-step label="Applicant" #candidateStep>
                    <fadv-icon library="solid" name="user"></fadv-icon>
                </fadv-step>
                <fadv-step label="Payment" #paymentStep>
                    <fadv-icon library="solid" name="credit-card"></fadv-icon>
                </fadv-step>
                <fadv-step label="Account" #accountStep>
                    <fadv-icon library="solid" name="user"></fadv-icon>
                </fadv-step>
                <fadv-step label="Credentialing" #credentialingStep>
                    <fadv-icon library="solid" name="flag-checkered"></fadv-icon>
                </fadv-step>
            </fadv-stepper>
        </div>       
    </fadv-layout-section>
</fadv-layout>

<!-- two divs, one for mobile one for desktop, smoother transition between vertical/horizontal position on stepper and more control over spacing -->